module.exports = __webpack_public_path__ + "static/media/icon_108.efff543b.svg";